import {Controller} from "../../interface/controller.interface";
import {Injectable} from "@angular/core";
import {HTTPService} from "../http.service";
import {EnvironmentService} from "../environment.service";
import {Observable} from "rxjs";
import {HTTPRequestBuilder} from "../../model/http.request.model";
import {HTTPMethod} from "../../model/http-method.enum";
import {SaveActionPointsDTO} from "../../model/club-gigot/action-points/save-action-point.model";
import {ExpirationConfigurationDto} from "../../model/club-gigot/expiration-configuration/expiration-configuration.dto";

/**
 * @description
 *  Servicio reflejo del controlador Configuracion
 */

@Injectable({ providedIn: "root" })
export class ConfigurationService implements Controller {

    constructor(private httpService: HTTPService, private environmentService: EnvironmentService) {}

    public hostPath() : string {
        return this.environmentService.rewardsBackendHost.href;
    }

    public basePath(): string {
        return "api/pointsConfiguration";
    }

    public getAllConfigurations() : Observable<ExpirationConfigurationDto[]>{
        return this.httpService.send<typeof undefined, ExpirationConfigurationDto[]>(
            new HTTPRequestBuilder<SaveActionPointsDTO>()
                .method( HTTPMethod.GET)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath('configurations')
                .build());
    }
    public getCurrentConfigurations(campaignSequence: number) : Observable<ExpirationConfigurationDto>{
        return this.httpService.send<typeof undefined, ExpirationConfigurationDto>(
            new HTTPRequestBuilder<typeof  undefined>()
                .method( HTTPMethod.GET)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath('configuration/'+campaignSequence)
                .build());
    }
    public saveConfiguration(configuration: ExpirationConfigurationDto, isEdit: boolean) : Observable<void>{
        return this.httpService.send<ExpirationConfigurationDto, void>(
            new HTTPRequestBuilder<ExpirationConfigurationDto>()
                .method(isEdit? HTTPMethod.PATCH : HTTPMethod.POST)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath('configuration')
                .payload(configuration)
                .build());
    }

    public deleteConfiguration(id: number) : Observable<void>{
        return this.httpService.send<typeof undefined, void>(
            new HTTPRequestBuilder<typeof undefined>()
                .method( HTTPMethod.DELETE)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath('configuration/' + id)
                .build());
    }

}
